module.exports = __webpack_public_path__ + "static/img/88036E_2_3_R_20190129_LC.085e5d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/88036E_2_3_R_20190129_LC.png
// module id = dlry
// module chunks = 0